(function () {
  var root = document.getElementById('fb-order');
  var cfgEl = document.getElementById('fb-config');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);

  var want = new URLSearchParams(location.search).get('edition');
  var state = {
    step: 0,
    counts: { adults: 1, kids: 0, pets: 0 },
    flags: [],
    people: [{ name: '', called: '', mobile: '', place: '', townOnly: false }],
    edition: cfg.editions.some(function (e) { return e.key === want; }) ? want : 'family'
  };
  var mins = { adults: 1, kids: 0, pets: 0 };
  var $ = function (id) { return document.getElementById(id); };
  var money = function (p) { return '£' + (p % 100 ? (p / 100).toFixed(2) : String(p / 100)); };
  var edition = function () { return cfg.editions.filter(function (e) { return e.key === state.edition; })[0] || cfg.editions[0]; };
  var val = function (id) { return ($(id).value || '').trim(); };
  var el = function (tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  };
  var filledPeople = function () { return state.people.filter(function (p) { return p.name.trim() || p.place.trim(); }); };
  var noPeople = function () { return edition().max === 0; };   // Your area and Essentials: no people pages or meeting plan
  var skipped = function (i) { return noPeople() && (i === 2 || i === 3); };   // steps: 0 book, 1 home, 2 people, 3 meeting plan, 4 check
  var kidCard = function () { return state.counts.kids > 0 && edition().key !== 'area' ? val('f-kid') : ''; };

  // Counters
  root.querySelectorAll('.counter').forEach(function (c) {
    var key = c.getAttribute('data-count');
    c.addEventListener('click', function (ev) {
      var b = ev.target.closest('button');
      if (!b) return;
      state.counts[key] = Math.max(mins[key], Math.min(20, state.counts[key] + Number(b.getAttribute('data-d'))));
      render();
    });
  });

  // Flags
  $('fb-flags').addEventListener('click', function (ev) {
    var b = ev.target.closest('.chip');
    if (!b) return;
    var f = b.getAttribute('data-flag');
    var i = state.flags.indexOf(f);
    if (i === -1) state.flags.push(f); else state.flags.splice(i, 1);
    b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
  });

  // People
  function drawPeople() {
    var box = $('fb-people');
    box.textContent = '';
    state.people.forEach(function (p, i) {
      var wrap = el('div', { class: 'person' });
      var head = el('div', { class: 'person-head' });
      head.appendChild(el('b', null, p.called || p.name || 'Person ' + (i + 1)));
      var rm = el('button', { type: 'button', class: 'textbtn' }, 'Remove');
      rm.addEventListener('click', function () { state.people.splice(i, 1); drawPeople(); render(); });
      head.appendChild(rm);
      wrap.appendChild(head);
      var row = el('div', { class: 'row' });
      [['name', 'Full name', 'name'], ['called', 'What should the book refer to them as?', 'off'], ['mobile', 'Mobile', 'off']].forEach(function (f) {
        var d = el('div');
        var id = 'p' + i + '-' + f[0];
        d.appendChild(el('label', { for: id }, f[1]));
        var inp = el('input', { id: id, type: f[0] === 'mobile' ? 'tel' : 'text', autocomplete: f[2], placeholder: f[0] === 'called' ? 'For example: Grandma' : '' });
        inp.value = p[f[0]];
        inp.addEventListener('input', function () { p[f[0]] = inp.value; if (f[0] !== 'mobile') head.firstChild.textContent = p.called || p.name || 'Person ' + (i + 1); render(); });
        d.appendChild(inp);
        row.appendChild(d);
      });
      wrap.appendChild(row);
      var pd = el('div');
      var pid = 'p' + i + '-place';
      pd.appendChild(el('label', { for: pid }, p.townOnly ? 'Their town' : 'Their address and postcode'));
      var pin = el('input', { id: pid, type: 'text', autocomplete: 'off' });
      pin.value = p.place;
      pin.addEventListener('input', function () { p.place = pin.value; });
      pd.appendChild(pin);
      var sw = el('button', { type: 'button', class: 'textbtn', style: 'margin-top:8px' }, p.townOnly ? 'I know their address' : 'I only know their town');
      sw.addEventListener('click', function () { p.townOnly = !p.townOnly; drawPeople(); });
      pd.appendChild(sw);
      if (p.townOnly) pd.appendChild(el('p', { class: 'hint' }, "We'll route you to the town centre and leave a line in the book to write their address in."));
      wrap.appendChild(pd);
      box.appendChild(wrap);
    });
    $('fb-add').hidden = state.people.length >= 8;
    $('fb-people-note').textContent = state.people.length >= 8 ? 'Up to 8 people per book.' : '';
  }
  $('fb-add').addEventListener('click', function () {
    state.people.push({ name: '', called: '', mobile: '', place: '', townOnly: false });
    drawPeople();
    var last = $('p' + (state.people.length - 1) + '-name');
    if (last) last.focus();
  });

  // Editions
  function drawEditions() {
    var box = $('fb-editions');
    box.textContent = '';
    cfg.editions.forEach(function (e) {
      var lab = el('label', { class: 'edition' });
      var r = el('input', { type: 'radio', name: 'edition', value: e.key });
      r.checked = e.key === state.edition;
      r.addEventListener('change', function () { state.edition = e.key; render(); });
      lab.appendChild(r);
      var main = el('span', { class: 'e-main' });
      main.appendChild(el('span', { class: 'e-name' }, e.name));
      main.appendChild(el('br'));
      main.appendChild(el('span', { class: 'e-blurb' }, e.blurb));
      lab.appendChild(main);
      lab.appendChild(el('span', { class: 'e-price' }, money(e.price)));
      box.appendChild(lab);
    });
  }

  // Printed copy: only offered once both print products are live in the shop
  var printed = function () { return !!cfg.print && $('f-print').checked; };
  var extra = function () { return printed() && !!cfg.extra && $('f-extra').checked; };
  if (cfg.print) {
    $('fb-printbox').hidden = false;
    $('fb-print-price').textContent = '+' + money(cfg.print.price);
    if (cfg.extra) $('fb-extra-price').textContent = '+' + money(cfg.extra.price);
  }
  $('f-print').addEventListener('change', function () {
    $('fb-extra-row').hidden = !(this.checked && cfg.extra);
    if (!this.checked) $('f-extra').checked = false;
    render();
  });
  $('f-extra').addEventListener('change', render);

  // Household bundle: the "Household bundle" automatic discount takes £5.99 off the printed copy bought with Family (£39 all in) or Full audit
  var BUNDLE_OFF = 599;
  // Shopify gives a book only one discount, so with a half-price second book the half price wins and the bundle drops off
  var bigBook = function () { return edition().key === 'family' || edition().key === 'audit'; };
  var bundle = function () { return printed() && bigBook() && !second(); };

  // Second address: a second book of the same edition for another home, half price through the
  // "Second address half price" automatic discount (Shopify rounds the discount down: £24.99 -> £12.50)
  var half = function (p) { return p - Math.floor(p / 2); };
  var second = function () { return $('f-second').checked; };
  $('f-second').addEventListener('change', function () {
    $('fb-secondbox').hidden = !this.checked;
    $('fb-secondbox').style.display = this.checked ? 'flex' : 'none';
    render();
  });
  $('f-s-address').addEventListener('input', render);
  ['f-s-postcode', 'f-s-email'].forEach(function (id) { $(id).addEventListener('input', render); });
  ['f-s-adults', 'f-s-kids'].forEach(function (id) { $(id).addEventListener('change', render); });
  var secondHousehold = function () {
    var a = Number($('f-s-adults').value), k = Number($('f-s-kids').value);
    return a + (a === 1 ? ' adult' : ' adults') + (k ? ', ' + k + (k === 1 ? ' child' : ' children') : '');
  };

  $('f-gift').addEventListener('change', function () {
    $('fb-giftbox').hidden = !this.checked;
    $('fb-giftbox').style.display = this.checked ? 'flex' : 'none';
    render();
  });

  function tooMany() {
    if (!noPeople() || !filledPeople().length) return '';
    return edition().name + " has no people pages or routes, so the people you added won't be in it. Choose Family to keep them.";
  }
  var bookPeople = function () { return noPeople() ? [] : filledPeople(); };

  function household() {
    var c = state.counts, out = [];
    out.push(c.adults + (c.adults === 1 ? ' adult' : ' adults'));
    if (c.kids) out.push(c.kids + (c.kids === 1 ? ' child' : ' children'));
    if (c.pets) out.push(c.pets + (c.pets === 1 ? ' pet' : ' pets'));
    return out.join(', ');
  }

  function personLine(p) {
    var bits = [p.called.trim() ? p.called.trim() + ': ' + p.name.trim() : p.name.trim()];
    if (p.mobile.trim()) bits.push(p.mobile.trim());
    bits.push((p.townOnly ? 'town: ' : '') + p.place.trim());
    return bits.join(', ');
  }

  function validate(step) {
    if (step === 0) {
      if ($('f-gift').checked && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('f-giftemail'))) return "Please add their email so we can send it to them.";
      if ($('f-gift').checked && val('f-giftemail').toLowerCase() !== val('f-giftemail2').toLowerCase()) return "The two email addresses don't match. Please check their email.";
    }
    if (step === 1) {
      if (!val('f-address')) return 'Please add your address.';
      if (!/^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/.test(val('f-postcode'))) return 'Please add a full UK postcode, like RG1 6AB.';
    }
    if (step === 2) {
      var bad = state.people.filter(function (p) { return (p.name.trim() || p.place.trim()) && (!p.name.trim() || !p.place.trim()); });
      if (bad.length) return 'Each person needs a name and an address or town.';
    }
    if (step === 4 && second()) {
      if (!val('f-s-address')) return 'Please add the address for the second book.';
      if (!/^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/.test(val('f-s-postcode'))) return 'Please add a full UK postcode for the second book, like RG1 6AB.';
      if (val('f-s-email') && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('f-s-email'))) return "Their email doesn't look right. Please check it, or leave it blank and we'll send the book to you.";
    }
    if (step === 4 && !$('f-consent').checked) return 'Please tick the box to confirm.';
    return '';
  }

  function review() {
    var dl = $('fb-review');
    dl.textContent = '';
    var add = function (k, v) { if (!v) return; var d = el('div'); d.appendChild(el('dt', null, k)); d.appendChild(el('dd', null, v)); dl.appendChild(d); };
    add('Home', val('f-address') + ', ' + val('f-postcode').toUpperCase());
    add('Household', household());
    add('Notes', state.flags.join(', '));
    if (!noPeople()) {
      bookPeople().forEach(function (p, i) { add('Person ' + (i + 1), personLine(p)); });
      add('Meet first at', val('f-meet1') || 'We suggest one near you');
      add('Then at', val('f-meet2'));
      add('Agreed check-in person', val('f-checkin'));
    }
    if (kidCard()) add("Child's card", val('f-kid'));
    add('Book', edition().name);
    if (printed()) add('Printed copies', (extra() ? '2' : '1') + ', posted to the address you give at checkout');
    if (bundle()) add('Household bundle', '£5.99 off the printed copy');
    if (second() && val('f-s-address')) add('Second book', edition().name + ' for ' + secondHome() + ', ' + secondHousehold() + (val('f-s-email') ? ', sent to ' + val('f-s-email') : ', sent to you'));
    if ($('f-gift').checked) { add('Gift for', val('f-giftemail')); add('Gift note', val('f-giftnote') || 'No note'); }
  }

  function secondHome() { return val('f-s-address') + ', ' + val('f-s-postcode').toUpperCase(); }

  function render() {
    root.querySelectorAll('.step').forEach(function (s) { s.classList.toggle('on', Number(s.getAttribute('data-step')) === state.step); });
    var shown = [];
    root.querySelectorAll('#fb-steps li').forEach(function (li, i) {
      li.hidden = skipped(i);
      li.className = i === state.step ? 'on' : (i < state.step ? 'done' : '');
      if (!li.hidden) shown.push(i);
    });
    $('fb-stepnum').textContent = 'Step ' + (shown.indexOf(state.step) + 1) + ' of ' + shown.length + ': ' + root.querySelectorAll('#fb-steps li')[state.step].textContent;
    $('fb-kidrow').hidden = !(state.counts.kids > 0 && edition().key !== 'area');
    root.querySelectorAll('.counter').forEach(function (c) { c.querySelector('output').textContent = state.counts[c.getAttribute('data-count')]; });
    $('fb-back').style.display = state.step === 0 ? 'none' : '';
    $('fb-next').textContent = state.step === 4 ? 'Go to payment' : 'Next';
    var tm = tooMany();
    $('fb-toomany').hidden = !tm;
    $('fb-toomany').textContent = tm;
    if (state.step === 4) review();

    var e = edition(), lines = $('fb-sum-lines');
    lines.textContent = '';
    var total = e.price;
    var line = function (a, b) { var d = el('div', { class: 'line' }); d.appendChild(el('span', null, a)); d.appendChild(el('span', null, b)); lines.appendChild(d); };
    line(e.name + ' (PDF)', money(e.price));
    if (printed()) { line('Printed and posted', money(cfg.print.price)); total += cfg.print.price; }
    if (extra()) { line('Second printed copy', money(cfg.extra.price)); total += cfg.extra.price; }
    if (bundle()) { line('Household bundle', '-' + money(BUNDLE_OFF)); total -= BUNDLE_OFF; }
    if (second()) { line(e.name + ' for ' + (val('f-s-address') || 'another address') + ' (half price)', money(half(e.price))); total += half(e.price); }
    $('fb-bundle').hidden = !(bigBook() && !second());
    // with Family, the print box shows what the printed copy really costs after the bundle saving
    if (cfg.print) {
      var pp = $('fb-print-price');
      pp.textContent = '';
      if (bigBook() && !second()) {
        pp.appendChild(el('s', { style: 'font-weight:400;opacity:.6' }, money(cfg.print.price)));
        pp.appendChild(document.createTextNode(' +' + money(cfg.print.price - BUNDLE_OFF)));
      } else pp.textContent = '+' + money(cfg.print.price);
    }
    $('fb-second-note').hidden = !(second() && printed() && bigBook());
    $('fb-second-price').textContent = '+' + money(half(e.price));
    $('fb-sum-total').textContent = money(total);
    var home = val('f-address');
    $('fb-sum-title').textContent = home ? 'Your book for ' + home : 'Your book';
    var eta = 'PDF by email within a day.';
    if ($('f-gift').checked) eta += ' Sent to them by email, with your note.';
    if (printed()) eta += ' Printed ' + (extra() ? 'copies' : 'copy') + ' delivered in 3 to 5 working days.';
    $('fb-sum-eta').textContent = eta;
  }

  function showError(msg) {
    var err = $('fb-error');
    if (state.step !== 4) {
      err = root.querySelector('.step.on .err') || (function () { var p = el('p', { class: 'err' }); root.querySelector('.step.on').appendChild(p); return p; })();
    }
    err.hidden = !msg;
    err.textContent = msg;
  }

  function checkout() {
    var props = {
      'Home': val('f-address') + ', ' + val('f-postcode').toUpperCase(),
      'Household': household()
    };
    if (state.flags.length) props['Notes'] = state.flags.join(', ');
    bookPeople().forEach(function (p, i) { props['Person ' + (i + 1)] = personLine(p); });
    if (!noPeople()) {
      if (val('f-meet1')) props['Meet first at'] = val('f-meet1');
      if (val('f-meet2')) props['Then at'] = val('f-meet2');
      if (val('f-checkin')) props['Agreed check-in person'] = val('f-checkin');
    }
    if (kidCard()) props["Child's card"] = val('f-kid');
    if ($('f-gift').checked) { props['Gift for'] = val('f-giftemail'); props['Gift note'] = val('f-giftnote') || '(no note)'; }
    // Hidden copy for the book builder (underscore properties don't show at checkout)
    props['_book'] = JSON.stringify({
      v: 1, edition: state.edition, address: val('f-address'), postcode: val('f-postcode').toUpperCase(),
      adults: state.counts.adults, kids: state.counts.kids, pets: state.counts.pets, flags: state.flags,
      people: bookPeople().map(function (p) { return { name: p.name.trim(), called: p.called.trim(), mobile: p.mobile.trim(), place: p.place.trim(), townOnly: p.townOnly }; }),
      meet1: noPeople() ? '' : val('f-meet1'), meet2: noPeople() ? '' : val('f-meet2'), checkin: noPeople() ? '' : val('f-checkin'), kid: kidCard(),
      gift: $('f-gift').checked ? { email: val('f-giftemail'), note: val('f-giftnote') } : null,
      print: printed() ? (extra() ? 2 : 1) : 0
    });

    var items = [{ id: edition().id, quantity: 1, properties: props }];
    if (printed()) items.push({ id: cfg.print.id, quantity: 1 });
    if (extra()) items.push({ id: cfg.extra.id, quantity: 1 });
    if (second()) {
      // its own line, so the book builder makes it as a separate book (order #1234-2)
      var sp = { 'Home': secondHome(), 'Household': secondHousehold(), 'Second address': 'Yes' };
      if (val('f-s-email')) { sp['Gift for'] = val('f-s-email'); sp['Gift note'] = '(no note)'; }
      sp['_book'] = JSON.stringify({
        v: 1, edition: state.edition, address: val('f-s-address'), postcode: val('f-s-postcode').toUpperCase(),
        adults: Number($('f-s-adults').value), kids: Number($('f-s-kids').value), pets: 0, flags: [], people: [],
        meet1: '', meet2: '', checkin: '', kid: '', gift: val('f-s-email') ? { email: val('f-s-email'), note: '' } : null, print: 0
      });
      items.push({ id: edition().id, quantity: 1, properties: sp });
    }

    var btn = $('fb-next');
    btn.disabled = true;
    btn.textContent = 'One moment';
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        // which homepage headline this visitor saw ("none" = came straight to the order page)
        var h = 'none';
        try { h = localStorage.getItem('fb_headline') || 'none'; } catch (e) {}
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { Headline: h } }) });
      })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; })
      .catch(function () {
        btn.disabled = false;
        render();
        showError('Something went wrong adding your book. Please try again, or email us.');
      });
  }

  $('fb-next').addEventListener('click', function () {
    var msg = validate(state.step);
    showError(msg);
    if (msg) return;
    if (state.step === 4) { checkout(); return; }
    state.step += 1;
    while (skipped(state.step)) state.step += 1;
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  $('fb-back').addEventListener('click', function () {
    showError('');
    state.step = Math.max(0, state.step - 1);
    while (skipped(state.step)) state.step -= 1;
    render();
  });
  $('f-address').addEventListener('input', render);

  drawPeople();
  drawEditions();
  render();
})();
